import { apiGet } from '../api-client'

export interface PublicTrendingVideo {
  id: string
  title: string
  thumbnail_url: string
}

export interface PublicTrendingResponse {
  videos: PublicTrendingVideo[]
}

export async function getTrendingPublic(limit: number = 6): Promise<PublicTrendingResponse> {
  const query = new URLSearchParams()
  if (limit) {
    query.set('limit', String(limit))
  }

  // Use a direct fetch here so we can explicitly omit credentials for this public endpoint.
  const url = `${import.meta.env.VITE_API_URL}/public/trending-videos${query.toString() ? `?${query.toString()}` : ''}`
  const res = await fetch(url, {
    method: 'GET',
    credentials: 'omit',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (!res.ok) {
    throw new Error('Failed to load trending videos')
  }

  return res.json()
}

